import React, { useCallback, useEffect } from 'react';
import { Typography, Box } from '@mui/material';
import { Button } from '@ui/buttons';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import amplitudeLog from '@client/amplitude';
import { useConfig } from '@client/providers/ConfigProvider';
import { getVersionMismatchReturnTo } from '@client/helpers/app-version-reload.helpers';

export const NewVersion: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { search } = useLocation();
  const reloadVersion = searchParams.get('reloadVersion');
  const returnTo = getVersionMismatchReturnTo(search);
  const navigate = useNavigate();
  const [config] = useConfig();

  const navigateToHome = useCallback(() => {
    navigate(returnTo);
  }, [navigate, returnTo]);

  useEffect(() => {
    if (config.version !== reloadVersion) {
      amplitudeLog('new-version-reloaded', {
        currentVersion: config.version,
        reloadVersion,
      });
    }
  }, [reloadVersion, config.version]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: '2rem',
      }}
    >
      <Typography variant="h4">Old version detected</Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '.5rem',
        }}
      >
        <Typography>
          A new version of the application has been released. To avoid issues,
          the application has restarted.
        </Typography>
        <Typography>
          We apologize for any inconvenience this may cause.
        </Typography>
        <Typography>
          If you continue to see this message, please open a new browser window
          and reload the application or contact support.
        </Typography>
      </Box>
      <Button variant="outlined" onClick={navigateToHome}>
        Return to application
      </Button>
    </Box>
  );
};
